module.exports = __webpack_public_path__ + "img/industrial_design_engineering_arch_rendering.ecac46ad.png";